<script setup lang="ts">
const visible = defineModel<boolean>('visible')
defineProps<{
  bandName: string
}>()
</script>

<template>
  <Dialog v-model:visible="visible" modal :closable="false" :style="{ width: '25rem' }">
    <div class="flex flex-col items-center text-center py-4">
      <div class="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mb-6 animate-bounce">
        <i class="pi pi-check-circle text-4xl text-teal-600"></i>
      </div>
      
      <h2 class="text-2xl font-black text-slate-900 mb-2">Congratulations!</h2>
      <p class="text-slate-600 mb-8 leading-relaxed">
        You are now an official member of <br/>
        <span class="font-bold text-teal-600 text-lg">"{{ bandName }}"</span>
      </p>

      <Button label="Awesome!" severity="success" class="w-full py-3 font-bold" @click="visible = false" />
    </div>
  </Dialog>
</template>
